module.exports = __webpack_public_path__ + "img/bg02.4a435205.gif";